import React from "react"
import { Link } from "gatsby"
import { teamsURL } from "@lib/urls"
import NoImg from "@images/noImage.png"
import { ContactTeamModalWithTrigger } from "@components/PopupForms/ContactTeamModal"

const NegoDetails = ({ negoDetails, propertyDetails, officeDetails }) => {
  let teamLink = `${teamsURL}`
  if(negoDetails?.slug){
    teamLink = `${teamsURL}${negoDetails.slug}/`
  }

  const image_link = negoDetails?.image?.url || negoDetails?.profile_img
  const phone_no = negoDetails?.phone || negoDetails?.work_phone
  return (
    <div className="property-nego">
      <div className="nego-name">
        <Link to={teamLink}>
          <img src={image_link || NoImg} alt={negoDetails?.name} />{" "}
          {negoDetails?.name}
        </Link>
      </div>
      <div className="divider">/</div>

      {phone_no && (
        <>
          <div className="nego-phone-email">
            <a href={`tel:${phone_no}`}>
              <i className="icon icon-phone" /> {phone_no}
            </a>
          </div>
          {process.env.GATSBY_FORMS_ENABLE === "true" && (
            <div className="divider">/</div>
          )}
        </>
      )}

      {process.env.GATSBY_FORMS_ENABLE === "true" && negoDetails?.email && (
        <div className="nego-phone-email">
          {/* <a href={`mailto:${negoDetails?.email}`}>
            <i className="icon icon-email" /> Email
          </a> */}
          <ContactTeamModalWithTrigger
            team={negoDetails}
            propertyDetails={propertyDetails}
            officeDetails={officeDetails}
          >
            <i className="icon icon-email" /> Email
          </ContactTeamModalWithTrigger>
        </div>
      )}
    </div>
  )
}
export default NegoDetails
